import React from 'react';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import 'rc-dropdown/assets/index.css';

const menu = (
  <Menu onSelect={() => {}} selectedKeys={[]}>
    <MenuItem key={1}>Excel (xlsx)</MenuItem>
    <MenuItem key={2}>PDF</MenuItem>
  </Menu>
);


const ExportarDropdown = () => {
    return null;    
}

//const ExportarDropdown = () => {

//    return (
//    <Dropdown
//       trigger={['click']}
//       overlay={menu}
//       animation="slide-up"
//    >
//      <button className="btn btn-default" type="button">
//         Exportar &nbsp;
//         <i className="fa fa-sort-desc" aria-hidden="true"></i>
//       </button>
//    </Dropdown>
//    );

//}

export default ExportarDropdown;
